<template>
    <div class="row">
        <div class="col-12 mt-4" v-if="!show_place">
            <transition name="fade" mode="out-in">
                <div key="mapa" id="mapa">
                    <NuevasAltasTeatroComponent v-on:goTo="goTo"></NuevasAltasTeatroComponent>
                </div>
            </transition>
        </div>
        <div class="col-12" v-if="show_place">
            <NuevasAltasComponent v-on:goTo="zonaSeleccionada" :place="place"></NuevasAltasComponent>
        </div>
    </div>
</template>

<script>
    import NuevasAltasTeatroComponent from '@/components/backend/stepper/components/NuevasAltasTeatroComponent';
    import NuevasAltasComponent from '@/components/backend/stepper/components/NuevasAltasComponent';

    export default {
        props: ['precios'],
        data() {
            return {
                zonas: null,
                show_place: false,
                place: null,
                datos_compradores: null,
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        methods: {
            goTo(paso, datos_compradores, recinto) {
                this.datos_compradores = datos_compradores;
                if(!recinto) {
                    this.$emit('goTo', paso, datos_compradores);
                } else {
                    this.place = recinto;
                    this.show_place = true;
                }
                
            },
            zonaSeleccionada(paso, zona, abono) {
                this.$emit('goTo', paso, this.datos_compradores, zona);
            },
            scrollTo (paso) {
                this.$scrollTo(paso, 100)
            },
        },
        components: {
            NuevasAltasTeatroComponent, NuevasAltasComponent
        }
    }
</script>

<style>

</style>
